/* eslint-disable */ 
import Vue from 'vue';
import Store from '../store/store';

const AuthFilter = (to, from, next) => {
  Vue.$log.debug(`In filter for ${to.path}`);
  // If we are on the login page, don't do the auth checks below
  if (to.name === 'login' || to.name === 'callback') {
    next();
    return;
  }
  // This function will return a token if a valid session is found
  // If not, go back to login page
  Store.dispatch('auth/getOrRefreshToken')
    .then((session) => {
      if (session) {
        next();
      } else {
        next({ name: 'login' });
      }
    }).catch((err) => {
      next({ name: 'login' });
    });
};

export default AuthFilter;
